import './components/ga-events';            //should be on top of each page's JS file
import "./components/wizcase-ad-cookies";
import './components/swipe-for-more';       // should be as soon as possible
import './parts/navigation';
import './parts/keyboard-navigation';
import './parts/accept-cookies';
import './parts/ftc-disclosure';
import './components/accessibility-widget';
import Tooltips from './components/tooltips';
import CustomSelect from './components/custom-select';
import './components/gallery';
import './components/js-links';
import './components/scroll-top-btn';
import './components/svg';
import './components/youtube-facade';

import '../vendor/splide.min';

import ExitPopup from './components/exit-popup';

import $ from 'cash-dom';
import PrequalState from './parts/ppc/prequalify-modal/PrequalState';

import initTocScrollspy from './parts/article/toc-scrollspy';
import initCouponCopy from './parts/article/coupon-copy';
import initVote from './parts/article/vote';
import initEditorNoteDismiss from './parts/article/editor-note-dismiss';
import loadDisclosureBanner from './parts/disclosure-banner-loader';
import initProsConsTabs from './parts/article/pros-cons-tabs';

PrequalState.getInstance().isPrequalShown = false;

if ($('#top_loans_carousel').length) {
  new Splide('#top_loans_carousel').mount();
}

$(function () {
  ExitPopup.init();
  Tooltips.getInstance().initOnce();
  CustomSelect.init();
  initTocScrollspy();
  initCouponCopy();
  initVote();
  initEditorNoteDismiss();
  loadDisclosureBanner();
  initProsConsTabs();

  let mobileModulesLoaded = false;
  let tocSheetLoaded = false;

  const loadMobileModules = () => {
    if (mobileModulesLoaded) return;
    mobileModulesLoaded = true;
    import('./parts/article/reading-progress').catch((err) => {
      console.error('Failed to load reading-progress module:', err);
    });
    import('./parts/article/sticky-deal-bar').catch((err) => {
      console.error('Failed to load sticky-deal-bar module:', err);
    });
  };

  const loadTocSheet = () => {
    if (tocSheetLoaded) return;
    tocSheetLoaded = true;
    import('./parts/article/toc-sheet').catch((err) => {
      console.error('Failed to load toc-sheet module:', err);
    });
  };

  const loadWhenMatched = (query, load) => {
    const mql = window.matchMedia(query);

    if (mql.matches) {
      load();
      return;
    }

    const listener = (e) => {
      if (e.matches) {
        load();
        if (mql.removeEventListener) {
          mql.removeEventListener('change', listener);
        } else if (mql.removeListener) {
          mql.removeListener(listener);
        }
      }
    };
    if (mql.addEventListener) {
      mql.addEventListener('change', listener);
    } else if (mql.addListener) {
      mql.addListener(listener);
    }
  };

  //X, Instagram, TikTok and Facebook posts in the content; matches SOCIAL_EMBED_SELECTOR in the module
  if (document.querySelector('blockquote.twitter-tweet, blockquote.instagram-media, blockquote.tiktok-embed, .fb-post, .fb-video')) {
    import('./parts/article/social-embeds').then(({default: initSocialEmbeds}) => {
      initSocialEmbeds();
    }).catch((err) => {
      console.error('Failed to load social-embeds module:', err);
    });
  }

  loadWhenMatched('(max-width: 767.9px)', loadMobileModules);
  loadWhenMatched('(max-width: 1199.9px)', loadTocSheet);

  //WizCase blog post: rating and Copy Link load on their first click
  if (document.querySelector('[data-blog-post-rating], [data-blog-post-share]')) {
    document.addEventListener('click', (e) => {
      const target = e.target.closest('[data-blog-post-rating] [data-stars], [data-blog-post-rating] [data-trustpilot-close], [data-blog-post-share] [data-copy-link]');

      if (!target) return;

      import('./parts/article/blog-post-actions').then(({default: handleBlogPostAction}) => {
        handleBlogPostAction(target);
      }).catch((err) => {
        console.error('Failed to load blog-post-actions module:', err);
      });
    });

    //a returning voter sees their own stars; legacy's cookie of this name holds legacy's post IDs, so only
    //votes cast on this site match
    const rating = document.querySelector('[data-blog-post-rating]');

    if (rating && document.cookie.indexOf('averegRating' + rating.dataset.postId + '=') !== -1) {
      import('./parts/article/blog-post-actions').then(({restoreVote}) => {
        restoreVote(rating);
      }).catch((err) => {
        console.error('Failed to load blog-post-actions module:', err);
      });
    }
  }

  //WizCase blog post comments: "Show more" and the reply counters load on their first click
  if (document.querySelector('[data-post-comments]')) {
    document.addEventListener('click', (e) => {
      const target = e.target.closest('[data-post-comments] [data-comments-more], [data-post-comments] [data-comment-replies], [data-post-comments] [data-comment-close]');

      if (!target) return;

      import('./parts/article/blog-post-comments').then(({default: handlePostCommentsAction}) => {
        handlePostCommentsAction(target);
      }).catch((err) => {
        console.error('Failed to load blog-post-comments module:', err);
      });
    });
  }

  //WizCase blog post "Leave a Comment" form, printed only while PostComments::FORM_ENABLED is on: its script
  //and reCAPTCHA load on the first focus in it, submit, Reply or Cancel
  const commentForm = document.querySelector('[data-comment-form]');

  if (commentForm) {
    const loadCommentForm = () => import('./parts/article/blog-post-comment-form').catch((err) => {
      console.error('Failed to load blog-post-comment-form module:', err);
    });

    commentForm.addEventListener('focusin', () => {
      loadCommentForm().then((module) => module && module.openForm(commentForm));
    });

    commentForm.addEventListener('submit', (e) => {
      e.preventDefault();
      loadCommentForm().then((module) => module && module.submitForm(commentForm));
    });

    document.addEventListener('click', (e) => {
      const target = e.target.closest('[data-post-comments] [data-comment-reply], [data-comment-form] [data-comment-cancel]');

      if (!target) return;

      loadCommentForm().then((module) => module && module.handleCommentFormAction(commentForm, target));
    });
  }
});
